module.exports = __webpack_public_path__ + "14c45ecc69136ef689a20e7b456593f9.svg";